import {inject, injectable} from 'inversify';

import type {FileModel} from '../../../../domain/File/File.model';
import type {UploadFileCmd} from '../UploadFile.cmd';

import {fileStore} from '../../../../../api/media/file';
import {FileMapperJrpc} from '../../../../domain/File/mappers/File.mapper.jrpc';

@injectable()
export class UploadFileCmdJrpc implements UploadFileCmd {
  constructor(
    @inject(FileMapperJrpc) private readonly mapper: FileMapperJrpc,
  ) {}

  async exec(props: UploadFileCmd.Props): Promise<FileModel> {
    const {file, meta} = props;

    const {mimetype, name, uploadingKey} = meta;

    const response = await fileStore.upload(file, {
      mimetype,
      name,
      uploadingKey,
    });

    return this.mapper.mapDataToModel(response);
  }
}
